import { useState, useEffect } from "react";
import { fetchWrapper } from "@/helpers/fetch-wrapper"; 

import { Sheet } from "react-modal-sheet";
import { Box, Grid, TextField, Typography, InputAdornment } from "@mui/material";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import LockIcon from "@mui/icons-material/Lock";

import NotificationSheet from "@/components/NotificationSheet";
import { useThemeMode } from "@/contexts/ThemeContext";

const ChangePasswordSheet = ({ open, onClose, loading = false }) => {
     const { isDarkMode } = useThemeMode(); 

     const [isOpen, setIsOpen] = useState(false); 
     const [notificationTitle, setNotificationTitle] = useState(''); 
     const [notificationMessage, setNotificationMessage] = useState(''); 
     const [notificationType, setNotificationType] = useState('warning'); 

	const [currentPassword, setCurrentPassword] = useState("");
	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");

	const handleModifyAccount = async () => {
		if (!currentPassword.length) {
			setNotificationTitle("Parola actuala");
               setNotificationMessage("Trebuie sa introduceti parola actuala.");  
               setIsOpen(true); 
               return; 
		}

          if (!newPassword.length) {
			setNotificationTitle("Parola noua");
               setNotificationMessage("Trebuie sa introduceti parola noua.");  
               setIsOpen(true); 
               return; 
		}

          if (!confirmPassword.length) {
			setNotificationTitle("Confirmarea parolei noi");
               setNotificationMessage("Trebuie sa introduceti confirmarea parolei noi.");  
               setIsOpen(true); 
               return; 
		}

          if(newPassword != confirmPassword) {
               setNotificationTitle("Parolele nu se potrivesc");
               setNotificationMessage("Parola noua si confirmarea nu se potrivesc.");  
               setIsOpen(true); 
               return; 
          }

          const resp = await fetchWrapper.post("/api/users/mobile/account", { currentPassword, newPassword, confirmPassword }); 

          if(resp.success) {
               setNotificationType('success'); 
               setNotificationTitle("Success !"); 
               setNotificationMessage("Parola contului a fost modificata cu success."); 
               setIsOpen(true); 
               setTimeout(() => {
                    setIsOpen(false);
                    window.location.href="/"; 
               }, 2000);
               return; 
          } else {
               setNotificationType('error'); 
               setNotificationTitle('Oops'); 
               setNotificationMessage(resp.error); 
               setIsOpen(true); 
               
               return; 
          }
	};

	return (
		<>
			<Sheet isOpen={open} onClose={onClose} snapPoints={[1]}>
				<Sheet.Container
					
					style={{
						borderTopLeftRadius: "0",
						borderTopRightRadius: "0",
						height: "100vh",
						maxHeight: "100vh",
						padding: "24px",
						boxSizing: "border-box",
                              backgroundColor: isDarkMode ? "#0d1015" : "#fff",
					}}>
					<Sheet.Header />
					<Sheet.Content style={{ display: "flex", flexDirection: "column", height: "100%" }}>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								marginBottom: "32px",
							}}>
							{/* Stânga: buton înapoi + titlu */}
							<div style={{ display: "flex", alignItems: "center" }}>
								<button
									onClick={onClose}
									style={{
										background: "none",
										border: "none",
										padding: 0,
										marginRight: 12,
										cursor: "pointer",
									}}>
									<ArrowBackIosNewIcon
										style={{ fontSize: 20, color: isDarkMode ? "#fff" : "#000" }}
									/>
								</button>
								<h2
									style={{
										margin: 0,
										fontSize: "20px",
										fontWeight: "600",
										color: isDarkMode ? "#fff !important" : "#000",
									}}>
									Modificare parolă
								</h2>
							</div>

							<button
								onClick={() =>
									handleModifyAccount({ currentPassword, newPassword, confirmPassword })
								}
								disabled={loading}
								style={{
									background: "none",
									border: "none",
									color: "#F0A500",
									fontSize: "16px",
									fontWeight: "500",
									cursor: "pointer",
									padding: 0,
								}}>
								{loading ? "Se salvează..." : "Salvează"}
							</button>
						</div>

						<Box className='glass-box' sx={{ flexGrow: 1 }}>
							<Grid container spacing={3}>
								{/* Parola actuală */}
								<Grid item xs={12}>
									<Typography
										component='label'
										sx={{
											fontWeight: 500,
											fontSize: "16px",
											mb: "10px",
											display: "block",
										}}>
										Parola actuală
									</Typography>

									<TextField
										placeholder='Introduceți parola actuală'
										variant='outlined'
										fullWidth
										type='password'
										value={currentPassword}
										onChange={(e) => setCurrentPassword(e.target.value)}
										InputProps={{
											startAdornment: (
												<InputAdornment position='start'>
													<LockIcon sx={{ fontSize: 20 }} />
												</InputAdornment>
											),
											sx: {
												"& input": {
													fontSize: "16px",
													padding: "26px 14px",
													lineHeight: "24px",
													boxSizing: "border-box",
													color: isDarkMode ? "#fff" : "#000",
												},
											},
										}}
									/>
								</Grid>

								{/* Parola nouă */}
								<Grid item xs={12}>
									<Typography
										component='label'
										sx={{
											fontWeight: 500,
											fontSize: "16px",
											mb: "10px",
											display: "block",
										}}>
										Parola nouă
									</Typography>

									<TextField
										placeholder='Introduceți parola nouă'
										variant='outlined'
										fullWidth
										type='password'
										value={newPassword}
										onChange={(e) => setNewPassword(e.target.value)}
										InputProps={{
											startAdornment: (
												<InputAdornment position='start'>
													<LockIcon sx={{ fontSize: 20 }} />
												</InputAdornment>
											),
											sx: {
												"& input": {
													fontSize: "16px",
													padding: "26px 14px",
													lineHeight: "24px",
													boxSizing: "border-box",
													color: isDarkMode ? "#fff" : "#000",
												},
											},
										}}
									/>
								</Grid>

								{/* Confirmare parolă nouă */}
								<Grid item xs={12}>
									<Typography
										component='label'
										sx={{
											fontWeight: 500,
											fontSize: "16px",
											mb: "10px",
											display: "block",
										}}>
										Confirmare parolă nouă
									</Typography>

									<TextField
										placeholder='Confirmați parola nouă'
										variant='outlined'
										fullWidth
										type='password'
										value={confirmPassword}
										onChange={(e) => setConfirmPassword(e.target.value)}
										InputProps={{
											startAdornment: (
												<InputAdornment position='start'>
													<LockIcon sx={{ fontSize: 20 }} />
												</InputAdornment>
											),
											sx: {
												"& input": {
													fontSize: "16px",
													padding: "26px 14px",
													lineHeight: "24px",
													boxSizing: "border-box",
													color: isDarkMode ? "#fff" : "#000",
												},
											},
										}}
									/>
								</Grid>
							</Grid>
						</Box>
					</Sheet.Content>
				</Sheet.Container>
				<Sheet.Backdrop />
			</Sheet>

			<NotificationSheet
				open={isOpen}
				onClose={() => setIsOpen(false)}
				type={notificationType}
				title={notificationTitle}
				message={notificationMessage}
				confirmText='Închide'
				withCancel={false}
				onConfirm={() => setIsOpen(false)}
				imageUrl={""}
			/>
		</>
	);
};

export default ChangePasswordSheet;
